import type { GetAggregatedMetrics200Data } from './getAggregatedMetrics200Data';

export type GetAggregatedMetrics200 = {
  data?: GetAggregatedMetrics200Data;
  endDate?: string;
  startDate?: string;
  userId?: string;
};
